<div class="container-fluid">
  <div class="row justify-content-between align-items-center mb-1">
    <div class="col">
      <h3>Sites</h3>
    </div>
    <div class="col-4">
      <button class="btn btn-primary h-100" (click)="addVendorToSites()">
        Add Vendor To Sites
      </button>
    </div>
  </div>

  <div class="row">
    <div class="col" style="height: 500px">
      <app-site-vendors-grid
        [gridName]="'AdminVendorSites'"
        [suppliedQueryData]="SuppliedGridQuery"
        [ColumnIdToColumnActions]="ColumnIdToColumnActions"
        (actionEvent)="actionEvent($event)"
        [suppressFieldDotNotation]="false"
        [(reloadGridData)]="reloadGrid"
      ></app-site-vendors-grid>
    </div>
  </div>
</div>
